import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";


const EditActionToBeTaken = () => {
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({});
  const location = useLocation();
  const { data } = location.state || {};
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const [validationErrors, setValidationErrors] = useState({});
  const [editActionToBeTaken, setEditActionToBeTaken] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchActionToBeTakenEdit();
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    userTypedropdown()
  },[])
  
  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
  
      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const fetchActionToBeTakenEdit = async () => {
    try {
      const response = await axiosInstance.get(`/actiontobetaken/edit/${data.action_tobe_taken_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const fetchedData = response.data.data; 
      const formatedData = {
        action_tobe_taken_name: fetchedData.action_tobe_taken_name,
        action_tobe_taken_desc: fetchedData.action_tobe_taken_desc,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
        business_partner_id:fetchedData.business_partner_id,
      }
      setFormData(formatedData)
      setEditActionToBeTaken(fetchedData);
      console.log("fetchedData", fetchedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No, cancel!",
    });
    if (!result.isConfirmed) {
      Swal.fire({
        title: "Cancelled",
        text: "The update action has been cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return; 
    }
    setLoading(true);
    try {
      const payload = {
        action_tobe_taken_name: formData.action_tobe_taken_name,
        action_tobe_taken_desc: formData.action_tobe_taken_desc,
        status: formData.status === "Active" ? 1 : 0,
      };
  
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }
  
      setIsFormSubmitted(true);
      await axiosInstance.patch(`/actiontobetaken/update/${data.action_tobe_taken_id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      showCustomAlert({
        title: "Success",
        text: "Action to be taken updated successfully!",
        icon: "success",
        confirmButtonText: "OK",
        callback: () => {
          navigate(ROUTES_NAVIGATION.ACTIONTOBETAKENLIST); 
        },
      });
    } catch (error) {
      console.error("Error updating action to be taken:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };
  

  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            
          },
        ]
      : []),
    {
      name: "action_tobe_taken_name",
      label: "Name",
      type: "text",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "action_tobe_taken_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
      <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" onClick={() => navigate(ROUTES_NAVIGATION.ACTIONTOBETAKENLIST)} />
        <span className="backbtntitle">Edit Action to be Taken</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Edit the Action to be Taken Details
        </span>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
      )}
    </>
  );
};

export default EditActionToBeTaken;
